import { Body, Box, Heading } from '@hover/blueprint';
import React from 'react';
import { useLocation } from 'react-router';

import { Alert } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import type { TranslationKey } from 'src/shared/hooks/useTranslate';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { TwoColumn } from 'src/shared/layouts';

const ERROR_PARAM = 'error';

const makeErrorKey = (param: string) => `singleSignOn.errorCode.${param}`;

const SingleSignOnFailure = ({ useNextStyle }: { useNextStyle?: boolean }) => {
  const t = useTranslate(TranslationNamespace.LOGIN);
  const param = new URLSearchParams(useLocation().search).get(ERROR_PARAM);

  const key = param && makeErrorKey(param);
  const error = key && t(key as TranslationKey);
  const message = error === key ? t('singleSignOn.unknownError') : error;

  // The design is still being worked on. This is a temporary version that looks okay within
  // the layout of the new onboarding flow.
  if (useNextStyle) {
    return (
      <Box
        alignItems="center"
        alignSelf="center"
        flexDir="column"
        height="100vh"
        justifyContent="center"
        maxWidth={800}
      >
        <Heading color="neutral700" margin={100} size={650} textAlign="center">
          {t('singleSignOn.error')}
        </Heading>
        <Body color="neutral600" margin={0} size={500} textAlign="center">
          {t('singleSignOn.somethingWrongWithSSOConfiguration')}
        </Body>
        {param && (
          <Alert color="danger" justifySelf="center" marginTop={400}>
            <Body m={0} size={400} textAlign="center">
              {message}
            </Body>
          </Alert>
        )}
      </Box>
    );
  }

  return (
    <TwoColumn.Main marginBottom={1000}>
      <Heading color="neutral700" margin={0} size={650} textAlign="center">
        {t('singleSignOn.error')}
      </Heading>
      <Body color="neutral600" margin={0} size={500} textAlign="center">
        {t('singleSignOn.somethingWrongWithSSOConfiguration')}
      </Body>
      {param && (
        <Alert color="danger" justifySelf="center" marginTop={400}>
          <Body m={0} size={400} textAlign="center">
            {message}
          </Body>
        </Alert>
      )}
    </TwoColumn.Main>
  );
};

export { SingleSignOnFailure };
